import { writable } from "svelte/store";
export function readWriteStore(initialValue) {
    let value = initialValue;
    const internalStore = writable(initialValue);
    internalStore.subscribe(v => value = v);
    return Object.assign(Object.assign({}, internalStore), { get: () => value });
}
;
